import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  public baseurl = environment.apiUrl;
  private adminApi = "api/Admin/";
  private commonApi = "api/Common/";
  private fleetmonApi = "api/Fleetmon/";

  constructor(private http: HttpClient) { }

  GetPortsList(data) {
    const url = this.baseurl + this.adminApi + 'GetPortsList';
    return this.http.post(url, data).pipe();
  }
  getRegions() {
    const url = this.baseurl + this.commonApi + 'GetRegions';
    return this, this.http.get(url).pipe();
  }
  GetPlanList(data) {
    const url = this.baseurl + this.adminApi + 'GetAllPlanList';
    return this.http.post(url, data).pipe();
  }

  GetPlanDetails(planId) {
    const url = this.baseurl + this.adminApi + 'GetPlanbyPlanId' + '?PlanId=' + planId;
    return this.http.get(url).pipe();
  }

  updatePlans(data) {
    const url = this.baseurl + this.adminApi + 'UpdatePlans';
    return this.http.post(url, data).pipe();
  }

  GetShippingLines() {
    const url = this.baseurl + this.commonApi + 'GetAllShippingLines';
    return this, this.http.get(url).pipe();
  }
  GetVessselsList(data) {
    const url = this.baseurl + this.adminApi + 'GetVessselsList';
    return this.http.post(url, data).pipe();
  }
  GetPortdetailsByPortId(id) {
    const url = this.baseurl + this.adminApi + 'GetPortdetailsByPortId' + '?PortId=' + id;
    return this.http.get(url).pipe();
    // const url = this.baseurl + this.adminApi + 'GetPortdetailsByPortId';
    // return this.http.get(url, data).pipe();
  }
  UpdatePorts(data) {
    const url = this.baseurl + this.adminApi + 'UpdatePorts';
    return this.http.post(url, data).pipe();
  }
  AddPortAliases(data) {
    const url = this.baseurl + this.adminApi + 'AddPortAliases';
    return this.http.post(url, data).pipe();
  }
  GetPortAliases(id) {
    const url = this.baseurl + this.adminApi + 'GetPortAliases' + '?PortId=' + id;
    return this.http.get(url).pipe();
  }
  DeletePortAliases(id) {
    const url = this.baseurl + this.adminApi + 'DeletePortAliases' + '?AliasId=' + id;
    return this.http.get(url).pipe();
  }
  CheckDuplicatePortCode(portCode) {
    const url = this.baseurl + this.adminApi + 'CheckDuplicatePortCode' + '?PortCode=' + portCode;
    return this.http.get(url).pipe();
  }

  GetuserList(data) {
    const url = this.baseurl + this.adminApi + 'GetAllUserList';
    return this.http.post(url, data).pipe();
  }

  GetAllPlans() {
    const url = this.baseurl + this.adminApi + 'GetAllPlans';
    return this.http.get(url).pipe();
  }

  GetUserdetails(userid) {
    const url = this.baseurl + this.adminApi + 'GetUserdetails' + '?userid=' + userid;
    return this.http.get(url).pipe();
  }

  ChangeMemberShipStatus(userid, planid, isadministrator, upgradeId, expiryDate) {
    const url = this.baseurl + this.adminApi + 'ChangeMemberShipStatus' + '?userId=' + userid + '&planId=' + planid + '&IsAdministrator=' + isadministrator + '&UpgradeId=' + upgradeId + '&UpgradeExpiryDate=' + expiryDate;
    return this.http.get(url).pipe();

  }
  GetVesselsdetailsByVesselsId(id) {
    const url = this.baseurl + this.adminApi + 'GetVesselsdetailsByVesselsId' + '?VesselsId=' + id;
    return this.http.get(url).pipe();
  }
  UpdateVessels(data) {
    const url = this.baseurl + this.adminApi + 'UpdateVessels';
    return this.http.post(url, data).pipe();
  }
  // Get APIList with ApiName, date, pageNo, pageSize parameter from Fleetmon API
  GetAPIList(apiName, date, pageNo, pageSize) {
    const url = this.baseurl + this.fleetmonApi + 'GetAPIDetailsList' + "?apiName=" + apiName + '&Date=' + date + "&PageNo=" + pageNo + "&PageSize=" + pageSize;
    return this, this.http.get(url).pipe();
  }

  GetFeelMonApiByCreatedDate(date) {
    const url = this.baseurl + this.fleetmonApi + 'GetFeelMonApiByCreatedDate' + "?Date=" + date;
    return this, this.http.get(url).pipe();
  }

  SaveUserApiQuota(data){
    const url = this.baseurl + this.adminApi + 'SaveUserApiQuota';
    return this.http.post(url, data).pipe();
  }

  RefreshAPIToken(data){
    const url = this.baseurl + this.adminApi + 'ResetApiKey' + "?userId=" + data;
    return this.http.post(url, null).pipe();
  }

  GetShippingLinesList(data){
    const url = this.baseurl + this.adminApi + 'GetShippingLinesList';
    return this.http.post(url, data).pipe();
  }

  GetShippingDetailsById(id) {
    const url = this.baseurl + this.adminApi + 'GetShippingLineDetails' + '?shippingId=' + id;
    return this.http.get(url).pipe();
  }

  SaveShippingLineDetails(data){
    const url = this.baseurl + this.adminApi + 'SaveShippingLineDetails';
    return this.http.post(url, data).pipe();
  }

}
